export default __webpack_public_path__ + "static/media/img-0211-mexico-full-face.53e1655c.png";